import { render } from "./RegisterStep2.view.vue?vue&type=template&id=12926f28"
import script from "./RegisterStep2.view.vue?vue&type=script&lang=js"
export * from "./RegisterStep2.view.vue?vue&type=script&lang=js"

import "./RegisterStep2.view.vue?vue&type=style&index=0&id=12926f28&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__